import React from "react";

import { useTranslation } from "react-i18next";

import {
  NotificationWrapper,
  EmptyNotificationImg,
  EmptyNotificationBody,
  Title,
  Text,
} from "./styles";

const EMPTY_NOTIFICATION_IMG = require("../../../../../assets/img/empty-notification.png");

export const EmptyNotificationList = () => {
  const { t: translate } = useTranslation();

  return (
    <NotificationWrapper>
      <EmptyNotificationImg src={EMPTY_NOTIFICATION_IMG} alt="empty-notification-img" />
      <EmptyNotificationBody>
        <Title>{translate("noNotificationsForNow")}</Title>
        <Text>
          {translate("notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn")}
        </Text>
      </EmptyNotificationBody>
    </NotificationWrapper>
  );
};
